import { useTranslate } from "@pankod/refine-core";
// import { SelectProps } from "@pankod/refine-antd";

import { Tag } from "@pankod/refine-antd";

type OrderStatusProps = {
  status: "Pending" | "Ready" | "On The Way" | "Delivered" | "Cancelled" | "Exists";
};

// export const OptionsOrderStatuses = () => {
//   const t = useTranslate();
//   const tr = "On The Way";
//   const optionOrderStatuses: SelectProps['options'] = [
//   	{ label: "Pending", value: t("enum.orderStatuses.Pending") },
//   	{ label: "Ready", value: t("enum.orderStatuses.Ready") },
//   	{ label: "On The Way", value: t(`enum.orderStatuses.${tr}`) },
//   	{ label: "Delivered", value: t("enum.orderStatuses.Delivered") },
//   	{ label: "Cancelled", value: t("enum.orderStatuses.Cancelled") },
//   ];

//   return {options: optionOrderStatuses};
// };

export const OrderStatus: React.FC<OrderStatusProps> = ({ status }) => {
  const t = useTranslate();
    let color;

    switch (status) {
        case "Pending":
            color = "orange";
            break;
        case "Ready":
            color = "cyan";
            break;
        case "On The Way":
            color = "green";
            break;
        case "Delivered":
            color = "blue";
            break;
        case "Cancelled":
            color = "red";
            break;
        case "Exists":
            color = "magenta";
            break;
    }

    return <Tag color={color}>{t(`enum.orderStatuses.${status}`)}</Tag>;
};
